import styled from "styled-components";
import theme from "../../../application/utils/Theme";

const InputLayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const InputField = styled.input`
        //background-color: #F5F5F5;
        border: 1px solid #e0e0e0;
        width: 100%;
        height: 40px;
        border-radius: 0.2em;
        font-size: 12px;
        outline: none;
        padding: 0 0.5em;
        letter-spacing: 0.05em;
       
        @media (min-width: ${theme.breakPoint['tablet']}) {
            font-size: 17px;
            border-radius: 0.4em;
            padding: 0.5em 0.5em;
        }
    `;

const SimpleInputLabel = styled.label`
        color: black;
        //opacity: ${props => props.opacity ? props.opacity : "49%"};
        font-size: 10px;
        font-weight: 500;
        letter-spacing: 0.05em;
        white-space: nowrap;
        text-transform:capitalize;
        @media (min-width: ${theme.breakPoint['tablet']}) {
           font-size: 15px;
        }
    `;



const TextError = styled.span`
        color: red;
        font-weight: 500;
        opacity: 40%;
        font-size: 10px;
        @media (min-width: ${theme.breakPoint['tablet']}) {
            font-weight: 600;
           font-size: 15px;
        }
        
    `

function SimpleLabledInput({ label, name, type, placeholder, ...rest }) {

    return (
        <InputLayout label={label} name={name} >
            <div>
                <InputField
                    type={type ? type : "text"}
                    placeholder={placeholder ? placeholder : ""}
                    id={name}
                    name={name}
                    {...rest}
                />
                {/* <ErrorMessage name={name} component={TextError} /> */}
            </div>
        </InputLayout>
    );
}

function InputLayout({ label, name, children }) {
    return (
        <InputLayoutContainer className="w-full">
            {
                label &&
                <div className="mb-2">
                    <SimpleInputLabel htmlFor={name}>{label}</SimpleInputLabel>
                </div>
            }
            {children}
        </InputLayoutContainer>
    )
}

export default SimpleLabledInput;

export { SimpleInputLabel, InputField ,InputLayout }